import { Table, TableCell, TableContainer, TableContainerProps, TableRow } from "@mui/material";
import styled from "styled-components";

interface IContainerProps {
	$marginCustom?: string;
	$widthCustom?: string;
}
export const Container = styled.div<IContainerProps>`
	margin: ${(props) => props.$marginCustom || "0"};
	width: ${(props) => props.$widthCustom || "unset"};
`;

export const Title = styled.h6`
	margin: 0 0 10px 0;
	font-weight: bold;
	color: #000;
`;
interface IStyledTable extends TableContainerProps {
	$sizeCell: "small" | "medium" | "large";
	$typeGrid: "oddEven" | "default" | "backgroundHeader" | "backgroundBody";
	$isFixedTable?: boolean;
	$breakpointTable?: number;
	$backgroundHeader?: string;
}
export const StyledTable = styled(Table) <IStyledTable>`
	&&& {
		min-width: 320px;
		border-collapse: collapse;
		${({ $isFixedTable }) => $isFixedTable && "table-layout: fixed;"}
		/* Styles size cell */
      ${(props) =>
		props.$sizeCell === "small" &&
		` .MuiTableCell-root {
      padding: 2px 8px;

    }
    `}
      ${(props) =>
		props.$sizeCell === "medium" &&
		`.MuiTableCell-root {
      padding: 6px 10px;
    }
  `}
      ${(props) =>
		props.$sizeCell === "large" &&
		`.MuiTableCell-root {
      padding: 10px 16px;
    }
  `}
      /* Styles type grid */ & .MuiTableRow-head {
			background: ${(props) => props.$backgroundHeader || props.theme.neutral.n50};

			.MuiTableCell-root {
				color: ${(props) => props.theme.neutral.n500};
				font-weight: bold;
				font-size: 0.8rem;
			}
		}

		${({ $typeGrid }) =>
		$typeGrid === "oddEven" &&
		`
      .MuiTableBody-root .MuiTableRow-root:nth-child(odd) {
        background-color: #fff;
      }

      .MuiTableBody-root .MuiTableRow-root:nth-child(even) {
        background-color: #f2f2f2;
      }
  `}

		${({ $typeGrid, theme }) =>
		$typeGrid === "backgroundBody" &&
		`
    .MuiTableBody-root .MuiTableRow-root {
      background-color: ${theme.grayLight};
    }
  `}

	@media (max-width: ${props => (props.$breakpointTable ? `${props.$breakpointTable}px` : '0px')}) {
			table-layout: auto;
		}
	}
`;
interface IStyledTableContainer extends TableContainerProps {
	$maxHeight?: string;
}
// prettier-ignore
export const StyledTableContainer = styled(TableContainer) <IStyledTableContainer>`
  &&& {
    max-height: ${({ $maxHeight }) => $maxHeight || '100%'};
  }
`;
export const BaseTableRowModalSide = styled(TableRow)`
	&&& {
		.MuiTableCell-root {
			padding: 6px 16px;
		}
	}
`;

interface IKOGTableRow {
	$isSizeLong?: boolean;
	$notClickable?: boolean;
	$notHover?: boolean;
}

export const KOGTableRow = styled(TableRow) <IKOGTableRow>`
	&&& {
		cursor: ${({ $notClickable }) => ($notClickable ? "default" : "pointer")};

		${({ $isSizeLong }) =>
		!$isSizeLong &&
		`
  .MuiTableCell-root {
    padding: 5px 20px;
  }
  `}

		${({ $notHover }) =>
		!$notHover &&
		`
      &:hover {
        background-color: #f5f5f5;
      }
    `}

    @media (max-width: 600px) {
			.MuiTableCell-root {
				padding: 8px 10px;
			}
		}
	}
`;

export const KOGTableCell = styled(TableCell)`
 	border: 1px solid rgb(229, 229, 229);
	border-right: none;
	border-left: none;
	&&& {
		font-size: 0.8rem !important;
		color: ${({ theme }) => theme.neutral.n600};
		line-height: 1.5rem;
	}
	&:first-of-type {
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		border-left: 1px solid rgb(229, 229, 229);
	}
	&:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-right: 1px solid rgb(229, 229, 229);
	}
`;

export const KOGTableRowModalSide = styled(TableRow) <IKOGTableRow>`
	cursor: pointer;
	border-bottom: none;

	${({ $isSizeLong }) =>
		!$isSizeLong &&
		`
  .MuiTableCell-root {
    padding: 5px 20px;
    border-bottom: none;
  }
  `}

	&:hover {
		background-color: #f5f5f5;
	}

	@media (max-width: 600px) {
		.MuiTableCell-root {
			padding: 8px 16px;
		}
	}
`;

export const EndMessage = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0px;
	text-align: center;
`;
